import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import "../components/Navbar.css";
import logo from "../assets/Logo.png";
import { Link, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navigate = useNavigate();

  const closeMenu = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  const handleGalleryClick = () => {
    closeMenu();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo-box" onClick={closeMenu}>
          <img src={logo} alt="logo" className="logo-img" />
          <p className="logo-text">AAPS</p>
        </Link>

        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <HiX /> : <HiMenu />}
        </div>

        <div className={`right-section ${menuOpen ? "active" : ""}`}>
          <ul className="nav-links">
            <li>
              <Link to="/" onClick={closeMenu}>
                Home
              </Link>
            </li>

            <li className="nav-item" onClick={() => toggleDropdown("courses")}>
              Courses
              {activeDropdown === "courses" && (
                <div className="hover-dropdown">
                  <Link to="/ai" onClick={closeMenu}>
                    AI
                  </Link>

                  <Link to="/java" onClick={closeMenu}>
                    Java Fullstack
                  </Link>

                  <Link to="/python-fullstack" onClick={closeMenu}>
                    Python Fullstack
                  </Link>

                  <Link to="/data-analysis" onClick={closeMenu}>
                    Data Analysis
                  </Link>

                  <Link to="/data-engineer" onClick={closeMenu}>
                    Data Engineering
                  </Link>
                </div>
              )}
            </li>

            <li className="nav-item" onClick={() => toggleDropdown("about")}>
              About Us
              {activeDropdown === "about" && (
                <div className="hover-dropdown">
                  <Link to="/about" onClick={closeMenu}>
                    About Us
                  </Link>

                  <Link to="/" onClick={handleGalleryClick}>
                    Gallery
                  </Link>
                </div>
              )}
            </li>

            <li
              className="nav-item"
              onClick={() => toggleDropdown("trainings")}
            >
              Trainings
              {activeDropdown === "trainings" && (
                <div className="hover-dropdown">
                  <Link to="/classroom" onClick={closeMenu}>
                    Classroom Training
                  </Link>

                  <Link to="/online" onClick={closeMenu}>
                    Online Training
                  </Link>
                  {/* <Link to="/project-training" onClick={closeMenu}>
                    Project Training
                  </Link> */}
                </div>
              )}
            </li>

            <li
              className="nav-item"
              onClick={() => toggleDropdown("placements")}
            >
              Placements
              {activeDropdown === "placements" && (
                <div className="hover-dropdown">
                  <Link to="/placed-candidates" onClick={closeMenu}>
                    Placed Candidates
                  </Link>

                  <Link to="/job-openings" onClick={closeMenu}>
                    Job Openings
                  </Link>
                </div>
              )}
            </li>

            <li>
              <Link to="/contact" onClick={closeMenu}>
                Contact Us
              </Link>
            </li>
          </ul>

          <Link to="/login" className="login-btn-navbar" onClick={closeMenu}>
            STUDENT LOGIN →
          </Link>
        </div>
      </div>
    </nav>
  );
}
